///import { AfterViewInit, Component, OnInit } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { ProductTile } from "../models/product-tile.model";
import { SliderScrollService } from "../ApplicationServices/SliderScrollService";
import { CollectionService } from '../ApplicationServices/CollectionService';
import { ProductDetailsService } from '../ApplicationServices/ProductDetailsService';
import { UserInfoStore } from "../shared/store/userInfo.store";
import { Router } from "@angular/router";
declare const $:any;


// Modal Block 1------------------
import { NgbModal, ModalDismissReasons, NgbModalOptions, NgbProgressbar } from '@ng-bootstrap/ng-bootstrap';
// Modal Block 1------------------

import { Component, OnInit, ViewChild, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';

//import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

// import { ViewChild, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
// import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';


import { ItemMasterBasic2_VariationService } from "../ApplicationServices/ItemMasterBasic2_VariationService";
import { RegistrationBasicService } from '../ApplicationServices/RegistrationBasicService';
import { RegistrationFeedbackService } from '../ApplicationServices/RegistrationFeedbackService';
import { RegistrationHealthService } from '../ApplicationServices/RegistrationHealthService';
import { SharedService } from '../ApplicationServices/SharedService';
import { PopUpService } from '../ApplicationServices/PopUpService';
import { UploadService } from '../ApplicationServices/UploadService';

import { ImageService } from '../ApplicationServices/ImageService';
import { BranchService } from '../ApplicationServices/BranchService';
import { CompanyService } from '../ApplicationServices/CompanyService';

import { ItemMasterHeaderSubDescService } from '../ApplicationServices/ItemMasterHeaderSubDescService';
import { LoginService } from "../ApplicationServices/LoginService";

//import { MatTableDataSource } from '@angular/material/table';
// import { MatPaginator } from '@angular/material/paginator';
// import { MatSort } from '@angular/material';



import { PopUpElement } from '../models/PopUpModel';
import { RegistrationBasicElement } from '../models/RegistrationBasicModel';
import { RegistrationFeedbackElement } from '../models/RegistrationFeedbackModel';
import { RegistrationHealthElement } from '../models/RegistrationHealthModel';
import { BranchElement } from '../models/BranchModel';
import { CompanyElement } from '../models/CompanyModel';
import { ImageElement } from '../models/ImageModel';
import { isDate } from "util";


@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  //providers:[SliderScrollService]
})
export class HomeComponent implements OnInit {

  CK_MANUAL_ATTENDANCE : boolean = false;
  CK_AUTO_ATTENDANCE : boolean = false;


  //closeResult: string;   
  moveForm: FormGroup;   moveModalReference: any;

  loggedIn = false;

  confirmDeleteImageReference: any;   empModalReference: any;   profile_img : string;
  imageToBeDeleted:any=null;    imageList=[];


  trade = [
    { label: 'Family Allow Dup Contact', selected: false }
    //, 
    // { label: 'bb', selected: false }, 
    // { label: 'cc', selected: false }, 
    // { label: 'dd', selected: false }
  ];


  
  EditOperation : boolean = false;
  EditeditOperation : boolean = false;

  isTrade: boolean = false;  checkAllTrades: boolean = false;

   testELEMENT_DATA: any;  testdataSource: any;   ROWCOUNT: number = 0;
  

  personidData:any;    departmentData:any;    designationData:any;    contractorData:any;    countryData:any;
   stateData:any;    cityData:any;    sexData:any;    religionData:any;    maritalData:any;
   bloodData:any;    relationData:any;    emptypeData:any;
   //stateData:any;


  zoneForm: any;   zoneModalReference: any; zoneData:any; 
  categorizeData:any;   categorizeData1:any;

  FixingHealthIssueData:any;  HealthIssueData:any;  
  UnderTreatmentData:any;  AddictionData:any;

  areaForm: any;   areaModalReference: any;   areaData:any;

  alertmsgOTP:string=null;showalertOTP:boolean=false;
  alertmsgOTP1:string=null;showalertOTP1:boolean=false;

  alertmsg:string=null;showalert:boolean=false;
  alertmsg1:string=null;showalert1:boolean=false;  alertmsg3:string=null;showalert3:boolean=false;
  
  ckVisibleOFF : boolean = false;
  ////////////////  timenow  /////////////////
  TIMINGNOW : string;   DATENOW : string;   RIDSS : string;


  AdmissionMasterIds:string=null;  AdmissionPersonalIds:string=null; AdmissionMasterCategoryIds:string=null; 
  AdmissionMasterCategorySubIds:string=null;  AdmissionStatuss:string=null; CompIds:string=null; 
  BranchIds:string=null;  HowKnowUss:string=null; FullNames:string=null; DOBs:string=null; 
  Ages:string=null;  SexIds:string=null;   ContactNos:string=null;   Emails:string=null;
  AdmissionDates:string=null;   AdmissionTimes:string=null;   PersonIDCategoryIds:string=null;   
  IDNOs:string=null;

  FamilyMembersCounts:string=null;  Country_Ids:string=null; State_Ids:string=null; 
  City_Ids:string=null;  PinCodes:string=null; AreaIds:string=null; ZoneIds:string=null; 
  PermanentAddresss:string=null;  TempAddresss:string=null; ReligionIds:string=null; MaritalStatusIds:string=null; 
  BloodGroupIds:string=null;  Nationalitys:string=null;   ReferralAdmissionMasterIds:string=null;   
  FamilyMembers:string=null;
  Codes:string=null;   CreatedBys:string=null;   MachineIPs:string=null;   
  

  leadsourceData:any;   yesnoData:any;
  HHID:string=null;  HHeight:string=null; HWeightStandard:string=null; HWeight:string=null;
  HWaist:string=null;  HHealthIssue:string=null; HUnderTreatment:string=null; HPracticeDeepSleep:string=null;
  HPracticeSleepHr:string=null;   HPracticeDailyWater:string=null;   HPracticeFoodHabit:string=null;   
  HPracticeAddiction:string=null;


  testingDataSet : any; 

  
    // Modal Block 2------------------
    modalOption: NgbModalOptions = {}; // not null!
    // Modal Block 2------------------

  closeResult: string;

  ///TIMINGNOW : string;
  customercategoryData :any;   customerstatusData :any;    companyData:any;   branchData:any;

  CKOTP: boolean = false;
  CK_IMG_PROFILE  : boolean = false;   CK_IMG_NOPROFILE  : boolean = false;
  CK_ID_REQ= false;   CK_CONTACTNO_REQ= false;   CK_deleteButton_VISIBILITY = false;   CK_performanceButton_VISIBILITY = false;
  
  CK_FM: boolean = false;   CK_Contact_Validation: boolean = false;

   CK_ACCESS_PANEL: boolean = false;   useroleid: number = 0;

  MID:number=0;  AIDD:number=0;  GID:number=0;   AID:number=0;  PID:number=0;   HID:number=0;   FID:number=0;
  IMGID:number=0;   IMGFOR:number=6;  //  EMP
  ARI : number =0;

  ZONENAME: string;  AREANAME: string;  CATEGORIZENAME: string;   HEALTH_HISTORY : string; 
  RIDS:string;    FNAME:string;   EARNINGSUM: string;  REDEEMSUM: string;  BALANCESUM: string;   
  POINTS:number=0;   FMID:number=0;   COUNTRYID:number=0;  STATEID:number=0;  CITYID:number=0;    CAID:number=0;

   ///showalert:boolean=false;alertmsg:string=null;
  //// EditOperation : boolean = false;   EditeditOperation : boolean = false;

  ELEMENT_DATA_basic: any;  dataSource_basic: any;
  ELEMENT_DATA_daily2011: any;  dataSource_daily2011: any;
  ELEMENT_DATA_daily2022: any;  dataSource_daily2022: any;
  
  ELEMENT_DATA: any;   IMAGE_ELEMENT_DATA: any;   dataSource: any;   imageDataSource: any;


  basicForm: any;   healthForm1: any; healthForm2: any;    feedbackForm: any; feedbackForm1: any;    imgvcdcategoryData:any;
  imagesForm: FormGroup;   videoForm: FormGroup;
  checkboxValue: boolean = false;    imgForm: FormGroup;


  debtorModalReference: any;  debtorModalOpen: boolean = true; 

  FullNaming :string=null;

  ELEMENT_DATA_basic1: any;  dataSource_basic1: any;
  ELEMENT_DATA_basic2: any;  dataSource_basic2: any;
  ELEMENT_DATA_basic3: any;  dataSource_basic3: any;
  ELEMENT_DATA_basic4: any;  dataSource_basic4: any;
  ELEMENT_DATA_basic5: any;  dataSource_basic5: any;
  ELEMENT_DATA_basic6: any;  dataSource_basic6: any;
  ELEMENT_DATA_basic7: any;  dataSource_basic7: any;
  ELEMENT_DATA_basic8: any;  dataSource_basic8: any;
  ELEMENT_DATA_basic9: any;  dataSource_basic9: any;

  CK71: boolean = false; CK72: boolean = false; CK73: boolean = false;
  CK74: boolean = false; CK75: boolean = false; CK76: boolean = false;
  CK77: boolean = false; CK78: boolean = false; CK79: boolean = false;

  CONTACTNO: string;   FAMILY: string;

  customerForm: FormGroup;   customerdetails = [];
  imgsForm: FormGroup;   imgsdetails = [];

  machineForm: FormGroup;   
  machinedetails1 = [];  machinedetails2 = [];  machinedetails3 = [];

  machineusedForm: FormGroup;    attendancedetailsForm: FormGroup; 
  machineuseddetails = [];  attendancedetails = [];

  machineusedForm1: FormGroup;   machineuseddetails1 = [];
  machineusedForm2: FormGroup;   machineuseddetails2 = [];
  machineusedForm3: FormGroup;   machineuseddetails3 = [];   

  customerForm1: FormGroup;   customerdetails1 = [];
  customerForm2: FormGroup;   customerdetails2 = [];


  constructor(

    // private sliderService: SliderScrollService,
    // private router: Router,
    // private collservice: CollectionService,
    // private detailService: ProductDetailsService,
    // private infoStore: UserInfoStore,

    private modalService: NgbModal,  
    private fb: FormBuilder,
    private compService: CompanyService, private braService: BranchService,  private imgService: ImageService, 

    private uploadsvc: UploadService,
    private baService :RegistrationBasicService ,    private heService: RegistrationHealthService,
    private variService: ItemMasterBasic2_VariationService,
    private feService: RegistrationFeedbackService,
    private shareService: SharedService, private popService :PopUpService,
    private headerservice:ItemMasterHeaderSubDescService, 
    private router: Router,
    private loginService: LoginService,

  ) {
    
    this.imgsForm = this.fb.group({ imgsdetails: [""], });

    this.machineForm = this.fb.group({
      machineuseddetails1: [null],
      machineuseddetails2: [null],
      machineuseddetails3: [null]
    });

    this.machineusedForm  = this.fb.group({ machineuseddetails: [""],  });  
    this.attendancedetailsForm  = this.fb.group({ attendancedetails: [""],  });  

    this.customerForm  = this.fb.group({ customerdetails: [""],  });     
    this.customerForm1 = this.fb.group({ customerdetails1: [""],  });
    this.customerForm2 = this.fb.group({ customerdetails2: [""],  });

    this.machineusedForm1 = this.fb.group({ machineuseddetails1: [""],  });
    this.machineusedForm2 = this.fb.group({ machineuseddetails2: [""],  });
    this.machineusedForm3 = this.fb.group({ machineuseddetails3: [""],  });

    this.moveForm = new FormGroup({
    email1: new FormControl()
    });
  

    this.basicForm = new FormGroup({


      FamilyMember: new FormControl(),
     AdmissionPersonalId: new FormControl(),
     //AdmissionAdditionalId: new FormControl(),
     AdmissionMasterId: new FormControl(),
  
     AdmissionMasterCategoryId: new FormControl(),
     AdmissionMasterCategorySubId: new FormControl(),
     AdmissionStatus: new FormControl(),
  
     CompId: new FormControl(),
     BranchId: new FormControl(),
     HowKnowUs: new FormControl(),
  
     FullName: new FormControl(),
     DOB: new FormControl(),
     Age: new FormControl(),
  
     AdmissionDate: new FormControl(),
     AdmissionTime: new FormControl(),

     IsFamily: new FormControl(),
  
  
  
     Country_Id: new FormControl(Validators.required),
     State_Id: new FormControl(Validators.required),
     City_Id: new FormControl(Validators.required),
     AreaId: new FormControl(),
     ZoneId: new FormControl(),
     PinCode: new FormControl(),
     TempAddress: new FormControl(),
     PermanentAddress: new FormControl(),
  
     SexId: new FormControl(),
     ReligionId: new FormControl(),
     MaritalStatusId: new FormControl(),
     BloodGroupId: new FormControl(),
     Nationality: new FormControl(),
  
     PersonIDCategoryId: new FormControl(),
     IDNO: new FormControl(),
     FamilyMembersCount: new FormControl(),
     Email: new FormControl(),
     ContactNo: new FormControl(),Code: new FormControl(),
  
  
     CreatedBy: new FormControl(),
     MachineIP:new FormControl(),
     ReferralAdmissionMasterId:new FormControl()
  
     });

     this.healthForm1 = new FormGroup({
      AdmissionHealthId: new FormControl(),
      AdmissionMasterId: new FormControl(),
 
      Height: new FormControl(),
      WeightStandard: new FormControl(),
      Weight:new FormControl(),
      Waist: new FormControl(),
 
      HealthIssue: new FormControl(),
      UnderTreatment: new FormControl(),
 
      PracticeDeepSleep: new FormControl(),
      PracticeSleepHr: new FormControl(),
      PracticeDailyWater: new FormControl(),
      PracticeFoodHabit: new FormControl(),
      PracticeAddiction: new FormControl(),
 
       //DrugTestId: new FormControl(),
      //DrugTestDate: new FormControl(new Date()),
 
     });

     this.feedbackForm = new FormGroup({

      AdmissionFeedbackId: new FormControl(),
      AdmissionMasterId: new FormControl(),
 
      //FeedBackDateTime: new FormControl(new Date()),
      FeedbackResult: new FormControl(),
      FeedbackNature: new FormControl(),
      HealthIssue: new FormControl(),
      OperatorsOpinion: new FormControl(),
      HealthCondition : new FormControl(),
      GuestRating: new FormControl(),
      // HealthCondition = 2;   GuestRating = 4; 
 
 
     });
 
     this.feedbackForm1 = new FormGroup({
 
       AdmissionFeedbackId: new FormControl(),
       AdmissionMasterId: new FormControl(),
  
       //FeedBackDateTime: new FormControl(new Date()),
       FeedbackResult: new FormControl(),
       FeedbackNature: new FormControl(),
       HealthIssue: new FormControl(),
       OperatorsOpinion: new FormControl(),
       HealthCondition : new FormControl(),
       GuestRating: new FormControl(),
       // HealthCondition = 2;   GuestRating = 4; 
  
  
      });
 
    this.imagesForm = new FormGroup({
      imagesList: this.fb.array([this.fb.group({ image: new FormControl(), ImageCategoryId: new FormControl()})])
    });
 
    this.videoForm = new FormGroup({
      videoList: this.fb.array([this.fb.group({ video: new FormControl(), ImageCategoryId: new FormControl()})])
    });

     this.areaForm = new FormGroup({
      PopName: new FormControl(),      
      ZoneId: new FormControl()

    });

    this.zoneForm = new FormGroup({
        PopName: new FormControl(),       
        PopId: new FormControl()

    });

     this.imagesForm = new FormGroup({
      imagesList: this.fb.array([this.fb.group({ image: new FormControl(), ImageCategoryId: new FormControl()})])
    });
 
    this.videoForm = new FormGroup({
      videoList: this.fb.array([this.fb.group({ video: new FormControl(), ImageCategoryId: new FormControl()})])
    });

     


  }


  ////////////////////  CHECKBOX //////////////////////

changeTradesByCategory(event) {

  if (event.target.name == 'trades') {
    this.isTrade = true;
    this.CK_FM = true ;
  }
  else{

    this.CK_FM = false ;

  }

  // if (this.isTrade && this.checkAllTrades) {
  //   event.target.checked = true
  // }


}

allTrades(event) {
  const checked = event.target.checked;
  this.trade.forEach(item => item.selected = checked);
}


get selectedimage() {
  return this.imgsForm.get("imgsdetails").value;
  //return this.AddressSelectionFormConsignee.get("shippingaddress").value;
}

  get selectedAdress() {

    return this.customerForm.get("customerdetails").value;
  
  }

  get selectedAdress1() {

    return this.customerForm1.get("customerdetails1").value;
  
  }

  get selectedAdress2() {

    return this.customerForm2.get("customerdetails2").value;
  
  }


  get selectedMachine1() {

    return this.machineusedForm1.get("machineuseddetails1").value;
  
  }

  onOptionsSelected(value){
    console.log(value);
   
    this.braService.getAllBranchDataByCompId(value).subscribe((data) => {
   
       this.branchData = data;
    }
    );
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
  const charCode = event.key.charCodeAt(0);
  if (charCode < 48 || charCode > 57) {
    event.preventDefault(); // Not a number
  }
  }

  onNumberInput(event: Event): void {
  const inputValue = (event.target as HTMLInputElement).value;

  if (inputValue === '') {
    this.basicForm.patchValue({ ContactNo: 0 });
  }
  }


  LoadBasic(){

    


    
  //  this.imagesForm.reset(); this.videoForm.reset();  this.basicForm.reset();
  //  this.healthForm1.reset(); this.healthForm2.reset(); this.feedbackForm.reset();  this.feedbackForm1.reset();


    this.CK_IMG_PROFILE = false ;   this.CK_IMG_NOPROFILE = true ;
   

    this.getAllCountry();  this.getAllBlood();  this.getAllMarital();  this.getAllRelation();
    this.getAllReligion();  this.getAllSex();  this.getAllPersonIDCategory();
    this.getLeadSourceList();  this.getYesNoList();  this.getAllZone();  this.getAllImgVcdCategory();

      

    this.baService.getAllAdmissionMasterCategorySubData(1).subscribe((datasx) => {

        this.customercategoryData = datasx;
       // creditorcategoryData:any; debtorcategoryData:any;

      }

    );

    this.baService.getAllAdmissionDetailsStatusData().subscribe((datasx) => {

        this.customerstatusData = datasx;
       // creditorcategoryData:any; debtorcategoryData:any;

      }

    );

    this.compService.getAllCompanyData().subscribe((data) => {

      this.companyData = data;

    }

  );


  //  ID_NO REQ -> YES/NO






  }

  CalculateTime(){


    var date = new Date();

     var dd = date.getDate();     
     var dds = Number(date.getDate().toString()) < 10 ? '0' + dd : dd;
    
      var mm = date.getMonth() + 1 ;         
      var mms = mm + 1 < 10 ? '0' + mm : mm; 
    
    var yy = date.getFullYear();
    ///  var mins = minutes < 10 ? '0' + minutes : minutes;

  
    var hours = date.getHours();
    var minutes = date.getMinutes();
  
    // Check whether AM or PM
    var ampm = hours >= 12 ? 'PM' : 'AM';
  
    // Find current hour in AM-PM Format
    hours = hours % 12;
  
    // To display "0" as "12"
    hours = hours ? hours : 12;
    var mins = minutes < 10 ? '0' + minutes : minutes;
  
    var timenow = hours + ':' + mins + ' ' + ampm ;
  
    console.log(hours + ':' + mins + ' ' + ampm);
  
    this.TIMINGNOW = timenow.toString();

    this.DATENOW = dds + '/' +  mms + '/' + yy ; 
  
    this.basicForm.patchValue({ AdmissionTime: this.TIMINGNOW });  
    this.basicForm.patchValue({ AdmissionDate: this.DATENOW });  
    this.basicForm.patchValue({ DOB: this.DATENOW }); 
  
  
   }


   tabChange(tab) {
    this.imagesForm = new FormGroup({
      imagesList: this.fb.array([this.fb.group({ image: new FormControl(), ImageCategoryId: new FormControl() })])
    });
 
    this.videoForm = new FormGroup({
      videoList: this.fb.array([this.fb.group({ video: new FormControl(), ImageCategoryId: new FormControl() })])
    });
 
   }


  openCity707(event){
 
    var i = event;

    if( i=="CUSTOMER"){

     // 1
     this.CK71=true;this.CK72=false;this.CK73=false;this.CK74=false;
     this.CK75=false;this.CK76=false;this.CK77=false;this.CK78=false;
     this.CK79=false;

    }
    else if (i=="DEBTOR"){

     //  2
     this.CK71=false;this.CK72=true;this.CK73=false;this.CK74=false;
     this.CK75=false;this.CK76=false;this.CK77=false;this.CK78=false;
     this.CK79=false;

    }

    else if (i=="CREDITOR"){

     // 3
     this.CK71=false;this.CK72=false;this.CK73=true;this.CK74=false;
     this.CK75=false;this.CK76=false;this.CK77=false;this.CK78=false;
     this.CK79=false;

    }

    else if (i=="EMPLOYEE"){
     
       // 4
       this.CK71=false;this.CK72=false;this.CK73=false;this.CK74=true;
       this.CK75=false;this.CK76=false;this.CK77=false;this.CK78=false;
       this.CK79=false;

    }

    else if (i=="BANK"){

         // 5
         this.CK71=false;this.CK72=false;this.CK73=false;this.CK74=false;
         this.CK75=true;this.CK76=false;this.CK77=false;this.CK78=false;
         this.CK79=false;

    }

    else if (i=="INCOME"){

         // 6
         this.CK71=false;this.CK72=false;this.CK73=false;this.CK74=false;
         this.CK75=false;this.CK76=true;this.CK77=false;this.CK78=false;
         this.CK79=false;

    }

    else if (i=="EXPENDITURE"){

          // 7
          this.CK71=false;this.CK72=false;this.CK73=false;this.CK74=false;
          this.CK75=false;this.CK76=false;this.CK77=true;this.CK78=false;
          this.CK79=false;

    }


    else if (i=="DOCTOR"){

            // 8
            this.CK71=false;this.CK72=false;this.CK73=false;this.CK74=false;
            this.CK75=false;this.CK76=false;this.CK77=false;this.CK78=true;
            this.CK79=false;

    }


    else if (i=="ASSOCIATE"){

            // 9
            this.CK71=false;this.CK72=false;this.CK73=false;this.CK74=false;
            this.CK75=false;this.CK76=false;this.CK77=false;this.CK78=false;
            this.CK79=true;

    }


  }



  openDebtorModal(content) {


    // Modal Block ------------------
      this.modalOption.backdrop = 'static';
      this.modalOption.keyboard = false;
    // Modal Block ------------------

  this.debtorModalOpen = true;

    this.debtorModalReference = this.modalService.open(content, {
      ariaLabelledBy: "modal-basic-title",
    });


      // Modal Block ------------------
     //   this.debtorModalReference = this.modalService.open(content, this.modalOption);
    // Modal Block ------------------


  this.debtorModalReference.result.then(
    (result) => {
      this.closeResult = `Closed with: ${result}`;
    },
    (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    }
  );


  //  Modal Block ------------------
  //return false;
 //  Modal Block ------------------


  }
  


  editCustomer1(id1, id2,  id3){

    this.EditOperation = true;  
    this.EditeditOperation = true;  

    ////  item.AdmissionMasterId, item.RID, item.FullName

    this.RIDS="";    this.FNAME= "";   this.MID = 0;

    this.RIDS= id2 ;    this.FNAME=id3 ;   this.MID = id1;

      

      this.baService.getAllRegistrationBasicByMIDData(id1)
      .subscribe(
      (data) => {

      this.testingDataSet = data;

      if(  this.testingDataSet.length == 0  ){
      
      
      }
      else{       

        this.AdmissionMasterIds =   data[0].AdmissionMasterId ;
        this.AdmissionPersonalIds =   data[0].AdmissionPersonalId ;
        this.AdmissionMasterCategoryIds =   data[0].AdmissionMasterCategoryId ;
        this.AdmissionMasterCategorySubIds =   data[0].AdmissionMasterCategorySubId ;

        this.AdmissionStatuss = data[0].AdmissionStatus ;  
        this.CompIds = data[0].CompId ; 
        this.BranchIds = data[0].BranchId ;   
        this.HowKnowUss = data[0].HowKnowUs ;
        this.FullNames = data[0].FullName ;   this.DOBs = data[0].DOB ;
        this.Ages = data[0].Age ;   
        this.SexIds = data[0].SexId ;      
        this.ContactNos = data[0].ContactNo ;   
        this.Emails = data[0].Email ;
        this.AdmissionDates = data[0].AdmissionDate ; 
        
        
        this.AdmissionTimes = data[0].AdmissionTime ;  
        this.PersonIDCategoryIds = data[0].PersonIDCategoryId ; 
        this.IDNOs = data[0].IDNO ;   
        this.FamilyMembersCounts = data[0].FamilyMembersCount ;
        this.Country_Ids = data[0].Country_Id ;   this.State_Ids = data[0].State_Id ;
        this.City_Ids = data[0].City_Id ;   
        this.PinCodes = data[0].PinCode ;      
        this.AreaIds = data[0].AreaId ;   
        this.ZoneIds = data[0].ZoneId ;
        this.PermanentAddresss = data[0].PermanentAddress ; 

        this.TempAddresss = data[0].TempAddress ;  
        this.ReligionIds = data[0].ReligionId ; 
        this.MaritalStatusIds = data[0].MaritalStatusId ;   
        this.BloodGroupIds = data[0].BloodGroupId ;
        this.Nationalitys = data[0].Nationality ;   
        this.ReferralAdmissionMasterIds = data[0].ReferralAdmissionMasterId ;
        this.FamilyMembers = data[0].FamilyMember ;   
        this.Codes = "0" ;      
        this.CreatedBys = data[0].CreatedBy ;   
        this.ZoneIds = data[0].ZoneId ;
        this.MachineIPs = data[0].MachineIP ; 

          this.baService.addZoneAreaData( 0 , Number(sessionStorage.getItem("LoggedInId")) , '', 2  )
          .subscribe(
            (data) => {
              this.zoneData = data;
            }
          );  

          this.baService.addZoneAreaData( Number(this.ZoneIds)  , Number(sessionStorage.getItem("LoggedInId")) , '', 2 )
          .subscribe(
            (data) => {
          
              this.areaData = data;
          }
          );



        //this.basicForm.patchValue({ AdmissionMasterId: this.AdmissionMasterIds });
        //this.basicForm.patchValue({ AdmissionPersonalId: this.AdmissionPersonalIds });
        this.basicForm.patchValue({ AdmissionMasterCategoryId: this.AdmissionMasterCategoryIds });
        this.basicForm.patchValue({ AdmissionMasterCategorySubId: this.AdmissionMasterCategorySubIds });
        this.basicForm.patchValue({ AdmissionStatus: this.AdmissionStatuss });     
        this.basicForm.patchValue({ CompId: this.CompIds });
        this.basicForm.patchValue({ BranchId: this.BranchIds });
        this.basicForm.patchValue({ HowKnowUs: this.HowKnowUss });
        this.basicForm.patchValue({ FullName: this.FullNames });
        this.basicForm.patchValue({ DOB: this.DOBs });
        this.basicForm.patchValue({ Age: this.Ages });
        this.basicForm.patchValue({ SexId: this.SexIds });

        this.basicForm.patchValue({ ContactNo: this.ContactNos });
        this.basicForm.patchValue({ Email: this.Emails });
        this.basicForm.patchValue({ AdmissionDate: this.AdmissionDates });
        this.basicForm.patchValue({ AdmissionTime: this.AdmissionTimes });
        this.basicForm.patchValue({ PersonIDCategoryId: this.PersonIDCategoryIds });     
        this.basicForm.patchValue({ IDNO: this.IDNOs });
        this.basicForm.patchValue({ FamilyMembersCount: this.FamilyMembersCounts });
        this.basicForm.patchValue({ Country_Id: this.Country_Ids });
        this.basicForm.patchValue({ State_Id: this.State_Ids });
        this.basicForm.patchValue({ City_Id: this.City_Ids });
        this.basicForm.patchValue({ PinCode: this.PinCodes });
        this.basicForm.patchValue({ AreaId: this.AreaIds });


        this.basicForm.patchValue({ ZoneId: this.ZoneIds });
        this.basicForm.patchValue({ PermanentAddress: this.PermanentAddresss });
        this.basicForm.patchValue({ TempAddress: this.TempAddresss });
        this.basicForm.patchValue({ ReligionId: this.ReligionIds });
        this.basicForm.patchValue({ MaritalStatusId: this.MaritalStatusIds });     
        this.basicForm.patchValue({ BloodGroupId: this.BloodGroupIds });
        this.basicForm.patchValue({ Nationality: this.Nationalitys });
        this.basicForm.patchValue({ ReferralAdmissionMasterId: this.ReferralAdmissionMasterIds });
        this.basicForm.patchValue({ FamilyMember: this.FamilyMembers });
        ///this.basicForm.patchValue({ PracticeDailyWater: this.HPracticeDailyWater });
        //this.basicForm.patchValue({ PracticeFoodHabit: this.HPracticeFoodHabit });
        //this.basicForm.patchValue({ PracticeAddiction: this.HPracticeAddiction });

        // this.HEALTH_HISTORY = data[0].HealthIssue ;
       ///this.HEALTH_HISTORY = this.HHealthIssue ;

      }  
   

    }

      );   

      

      this.testingDataSet = null;    this.HEALTH_HISTORY = '' ;

      this.heService.getAllRegistrationHealthData(id1)
      .subscribe(
      (data) => {

      this.testingDataSet = data;

      if(  this.testingDataSet.length == 0  ){

        this.HHID =   '0' ;
        this.HHeight =''  ;  this.HWeightStandard = ''; 
        this.HWeight = '' ;   this.HWaist ='' ;
        this.HHealthIssue = '' ;   this.HUnderTreatment ='';
        this.HPracticeDeepSleep = '' ;   
        this.HPracticeSleepHr = '' ;      
        this.HPracticeDailyWater ='' ;   
        this.HPracticeFoodHabit = '' ;
        this.HPracticeAddiction ='' ; 


        this.healthForm1.patchValue({ AdmissionHealthId: this.HHID });
        this.healthForm1.patchValue({ Height: this.HHeight });
        this.healthForm1.patchValue({ WeightStandard: this.HWeightStandard });
        this.healthForm1.patchValue({ Weight: this.HWeight });
        this.healthForm1.patchValue({ Waist: this.HWaist });
     
        this.healthForm1.patchValue({ HealthIssue: this.HHealthIssue });
        this.healthForm1.patchValue({ UnderTreatment: this.HUnderTreatment });
        this.healthForm1.patchValue({ PracticeDeepSleep: this.HPracticeDeepSleep });
        this.healthForm1.patchValue({ PracticeSleepHr: this.HPracticeSleepHr });
        this.healthForm1.patchValue({ PracticeDailyWater: this.HPracticeDailyWater });
        this.healthForm1.patchValue({ PracticeFoodHabit: this.HPracticeFoodHabit });
        this.healthForm1.patchValue({ PracticeAddiction: this.HPracticeAddiction });

        this.HEALTH_HISTORY = this.HHealthIssue ;

      }
      else{       

        this.HHID =   data[0].AdmissionHealthId ;
        this.HHeight = data[0].Height ;  this.HWeightStandard = data[0].WeightStandard ; 
        this.HWeight = data[0].Weight ;   this.HWaist = data[0].Waist ;
        this.HHealthIssue = data[0].HealthIssue ;   this.HUnderTreatment = data[0].UnderTreatment ;
        this.HPracticeDeepSleep = data[0].PracticeDeepSleep ;   
        this.HPracticeSleepHr = data[0].PracticeSleepHr ;      
        this.HPracticeDailyWater = data[0].PracticeDailyWater ;   
        this.HPracticeFoodHabit = data[0].PracticeFoodHabit ;
        this.HPracticeAddiction = data[0].PracticeAddiction ;  

        this.healthForm1.patchValue({ AdmissionHealthId: this.HHID });
        this.healthForm1.patchValue({ Height: this.HHeight });
        this.healthForm1.patchValue({ WeightStandard: this.HWeightStandard });
        this.healthForm1.patchValue({ Weight: this.HWeight });
        this.healthForm1.patchValue({ Waist: this.HWaist });
     
        this.healthForm1.patchValue({ HealthIssue: this.HHealthIssue });
        this.healthForm1.patchValue({ UnderTreatment: this.HUnderTreatment });
        this.healthForm1.patchValue({ PracticeDeepSleep: this.HPracticeDeepSleep });
        this.healthForm1.patchValue({ PracticeSleepHr: this.HPracticeSleepHr });
        this.healthForm1.patchValue({ PracticeDailyWater: this.HPracticeDailyWater });
        this.healthForm1.patchValue({ PracticeFoodHabit: this.HPracticeFoodHabit });
        this.healthForm1.patchValue({ PracticeAddiction: this.HPracticeAddiction });

        // this.HEALTH_HISTORY = data[0].HealthIssue ;
        this.HEALTH_HISTORY = this.HHealthIssue ;

      }  
   

    }

      );   


      this.getimagesForMID();

      //this.LoadMachineData();   
      this.GetAllMachineAttendanceByMID();

    
  }
  
  editCustomer2(id1, id2){

    this.basicForm.patchValue({ReferralAdmissionMasterId:''});

    var str=null;
    str= id1 +'#'+ id2 ;
    this.basicForm.patchValue({ReferralAdmissionMasterId:str});

    ////this.RIDSS =id;
   
    ///var comp = null;

      // this.loginService
      // .getAllAppUserByIdData(id)
      // .subscribe((event: any) => {
      //   if (event.length > 0) {
      //     comp = event;
            
      //     this.ConsignorForm.setValue({

      //       UserId : id,
      //       //Country_Id :101,
      //       UserFullName:event[0].UserFullName,
      //       UserContactNO :event[0].UserContactNO,
      //       UserMail :event[0].UserMail,
      //       UserPassword :event[0].UserPassword,
      //       confirmedPassword :event[0].UserPassword,


      //     });

      //   }
      // });

  }



  openMoveModal1(content) {
    this.moveForm.reset();
    this.moveModalReference = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
    this.moveModalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });


  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
     return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
     return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
   }
  }

  onMoveInfoSubmit(){

    if( this.moveForm.value.email1=='' ){

      this.alertmsg = "Enter Username i.e. Registered E-mail !!";
      this.showalert1 = true;
      setTimeout(() => {
        this.showalert1 = false;
      }, 3000);
     return;

    }


   
    this.moveModalReference.close();

     this.alertmsg3 = "New Password will be send shortly to your registered E-mail !";
     this.showalert3 = true;
     setTimeout(() => {
     this.showalert3 = false;
     }, 5000);


  }


  onVisitorLoadData(){

  this.alertmsg="data loading ..... !!";
  this.showalert=true;
 
  this.getVisitorData();

  this.alertmsg="data loading ..... !!";
  this.showalert=true;
  setTimeout(() => {
    this.showalert=false;
  }, 5000);




  }



    onNewVisitorData(){

     // this.itemsForm.controls['ItemProductTypeId'].enable();   
    ///this.itemsForm.controls['ItemProductTypeId'].disable();
   
    
    this.basicForm.controls['FullName'].enable(); 
    this.basicForm.controls['DOB'].enable(); 
    this.basicForm.controls['ContactNo'].enable(); 

    this.EditOperation=false; this.EditeditOperation = false;  this.MID=0;
    this.basicForm.reset();     this.healthForm1.reset();  this.imagesForm.reset(); 
    this.CalculateTime();
    this.FNAME ="";     this.RIDS ="";    this.profile_img ="";
  
    }


    
    onVisitorLoadData2(){

      this.alertmsg="data loading ..... !!";
      this.showalert=true;
     
      this.getVisitorData2();
    
      this.alertmsg="data loading ..... !!";
      this.showalert=true;
      setTimeout(() => {
        this.showalert=false;
      }, 5000);
    
    
    
    
    }   


  getVisitorData(){

    this.baService.getAllRegistrationBasicData( "NO",Number(sessionStorage.getItem("LoggedInId")), 1, 13 )
      .subscribe((event: any) => {
  
  
     /// this.ELEMENT_DATA_basic1 = datacc;
      //this.dataSource_basic1 = new MatTableDataSource(this.ELEMENT_DATA_basic1);
       ///  this.dataSource_basic1.paginator = this.paginator;
      ///  this.dataSource_basic1.sort = this.sort;

       if (event.length > 0) {

            this.customerdetails = event;


          } else {
            this.customerdetails = [];
          }
  
    }
       );
  


  }

  getVisitorData1(){

    this.baService.getAllRegistrationBasicData( "NO",Number(sessionStorage.getItem("LoggedInId")), 1, 13 )
      .subscribe((event: any) => {
  
  
     /// this.ELEMENT_DATA_basic1 = datacc;
      //this.dataSource_basic1 = new MatTableDataSource(this.ELEMENT_DATA_basic1);
       ///  this.dataSource_basic1.paginator = this.paginator;
      ///  this.dataSource_basic1.sort = this.sort;

       if (event.length > 0) {

            this.customerdetails1 = event;


          } else {
            this.customerdetails1 = [];
          }
  
    }
       );
  


  }

  getVisitorData2(){

    this.baService.getAllRegistrationBasicData( "NO",Number(sessionStorage.getItem("LoggedInId")), 1, 13 )
      .subscribe((event: any) => {
  
  
     /// this.ELEMENT_DATA_basic1 = datacc;
      //this.dataSource_basic1 = new MatTableDataSource(this.ELEMENT_DATA_basic1);
       ///  this.dataSource_basic1.paginator = this.paginator;
      ///  this.dataSource_basic1.sort = this.sort;

       if (event.length > 0) {

            this.customerdetails2 = event;


          } else {
            this.customerdetails2 = [];
          }
  
    }
       );
  


  }
 
  getAllBasicFillForSearch() {

    ///.getCartItemsOrdered( Number(sessionStorage.getItem("LoggedInId")) )
  ///  .subscribe((event: any) => {

    // CUSTOMER
    ///this.baService.getAllRegistrationBasicData( "NO",Number(sessionStorage.getItem("LoggedInId")), 1, 0)
    ////.subscribe(
    ///(datacc) => {
   /// ((event: any) => {


    
  
    //  DEBTOR
    this.baService.getAllRegistrationBasicData( "NO",Number(sessionStorage.getItem("LoggedInId")), 2, 0)
    .subscribe(
      (datacc) => {
    
  
        this.ELEMENT_DATA_basic2 = datacc;
        //this.dataSource_basic2 = new MatTableDataSource(this.ELEMENT_DATA_basic2);
          /// this.dataSource_basic2.paginator = this.paginator;
        //  this.dataSource_basic2.sort = this.sort;
  
      }
    );
  
  
    //  CREDITOR
    this.baService.getAllRegistrationBasicData( "NO",Number(sessionStorage.getItem("LoggedInId")), 3, 0)
    .subscribe(
      (datacc) => {
      
  
        this.ELEMENT_DATA_basic3 = datacc;
        //this.dataSource_basic3 = new MatTableDataSource(this.ELEMENT_DATA_basic3);
          /// this.dataSource_basic3.paginator = this.paginator;
        //  this.dataSource_basic3.sort = this.sort;
  
      }
    );
  
  
    //  EMPLOYEE
    this.baService.getAllRegistrationBasicData( "NO",Number(sessionStorage.getItem("LoggedInId")), 4, 0)
    .subscribe(
      (datacc) => {
    
  
        this.ELEMENT_DATA_basic4 = datacc;
        //this.dataSource_basic4 = new MatTableDataSource(this.ELEMENT_DATA_basic4);
          /// this.dataSource_basic4.paginator = this.paginator;
        //  this.dataSource_basic4.sort = this.sort;
  
      }
    );
  
    
    //  BANK
    this.baService.getAllRegistrationBasicData( "NO",Number(sessionStorage.getItem("LoggedInId")), 5, 0)
    .subscribe(
      (datacc) => {
    
  
        this.ELEMENT_DATA_basic5 = datacc;
        //this.dataSource_basic5 = new MatTableDataSource(this.ELEMENT_DATA_basic5);
          /// this.dataSource_basic5.paginator = this.paginator;
        // this.dataSource_basic5.sort = this.sort;
  
      }
    );
  
      
    //  INCOME
    this.baService.getAllRegistrationBasicData( "NO",Number(sessionStorage.getItem("LoggedInId")), 6, 0)
    .subscribe(
      (datacc) => {
    
  
        this.ELEMENT_DATA_basic6 = datacc;
        //this.dataSource_basic6 = new MatTableDataSource(this.ELEMENT_DATA_basic6);
          ///this.dataSource_basic6.paginator = this.paginator;
        // this.dataSource_basic6.sort = this.sort;
  
      }
    );
  
      
    //  EXPENDITURE
    this.baService.getAllRegistrationBasicData( "NO",Number(sessionStorage.getItem("LoggedInId")), 7, 0)
    .subscribe(
      (datacc) => {
    
  
        this.ELEMENT_DATA_basic7 = datacc;
        //this.dataSource_basic7 = new MatTableDataSource(this.ELEMENT_DATA_basic7);
          //this.dataSource_basic7.paginator = this.paginator;
        //this.dataSource_basic7.sort = this.sort;
  
      }
    );
  
           
    //  DOCTOR
    this.baService.getAllRegistrationBasicData( "NO",Number(sessionStorage.getItem("LoggedInId")), 8, 0)
    .subscribe(
      (datacc) => {
    
  
        this.ELEMENT_DATA_basic8 = datacc;
        //this.dataSource_basic8 = new MatTableDataSource(this.ELEMENT_DATA_basic8);
         //this.dataSource_basic8.paginator = this.paginator;
        //this.dataSource_basic8.sort = this.sort;
  
      }
    );
  
  
  
       //  ASSOCIATE
       this.baService.getAllRegistrationBasicData( "NO",Number(sessionStorage.getItem("LoggedInId")), 9, 0)
       .subscribe(
         (datacc) => {
       
  
           this.ELEMENT_DATA_basic9 = datacc;
           //this.dataSource_basic9 = new MatTableDataSource(this.ELEMENT_DATA_basic9);
            //this.dataSource_basic9.paginator = this.paginator;
           //this.dataSource_basic9.sort = this.sort;
  
         }
       );
  
  
  
  
      // this.showalert = true;
     // setTimeout(() => {
    // this.showalert = false;
   // }, 2000);
  
  
  }
   


    
  
  
  onDOBSubmit(datas){

    var objj = new RegistrationBasicElement();
    objj.DOB = datas.DOB;
  
    this.baService.addDOBToAgeData(objj)
        .subscribe(
          (datas) => {
  
            var str=null;
            str= datas[0].OperationStatus;
            this.basicForm.patchValue({Age:str});
  
          });
  
  
  }

  
onGenerateOTPSubmit(datas){

  //this.CK_CONTACTNO_REQ

  this.CONTACTNO = datas.ContactNo ;



  this.headerservice.getAllItemMasterHeaderSubDescBySubId( 0 , 9 , 5221 )
  .subscribe(
  (data1) => {       
   
  var spc1 = data1[0].ItemMasterHeaderSubDesc.toString().split("#")[0];
   
  if(  spc1 == 'YES'  )
  {
      
    this.CK_CONTACTNO_REQ= true;    

  }
  else if(  spc1 == 'NO'  )
  {
      
    this.CK_CONTACTNO_REQ= false;  

  }


    if(  this.CK_CONTACTNO_REQ ==  true )
    {

        /////  Contact No can not be blank to generate OTP
        if( datas.ContactNo ==null  )
        {
      
          this.alertmsgOTP="Contact No can not be blank to generate OTP !";
          this.showalertOTP=true;
          setTimeout(() => {
          this.showalertOTP=false;
          }, 2000);
      
          this.CK_Contact_Validation = false ; 
      
          return;
        }
        else
        {
        
          //////  Give 10 digit mobile number along with 91 i.e. 12 digits to generate OTP
          if(  datas.ContactNo.length < 12  )
          {
      
            this.alertmsgOTP="Give 10 digit mobile number along with 91 i.e. 12 digits to generate OTP !";
                this.showalertOTP=true;
                setTimeout(() => {
                this.showalertOTP=false;
                }, 2000);
      
                this.CK_Contact_Validation = false ; 
      
                return;
      
          }
      
        }
  

        if(  this.CK_FM == true )
        {

          this.baService.DuplicacyCheckForContactNOData( datas.ContactNo )
          .subscribe(
                (datas) => {
        
                  var str1=null;
                  str1 = datas[0].OperationStatus; 
                                    
                  if(  str1 =='Duplicate Conatct No Found !' )
                  {
                                    
                        this.alertmsgOTP= "Belonging to same family allows duplicate contact no." ;
                        this.showalertOTP=true;
                        setTimeout(() => {
                        this.showalertOTP=false;
                        }, 5000);

                        this.CK_Contact_Validation = true ; 
    
                        return;    
                    
                  }  
                  
                  else if( str1=='Contact No verified succesfully !' ){
    
                    var objj = new RegistrationBasicElement();
                    objj.ContactNo = this.CONTACTNO ;
                  
                  
                    this.alertmsgOTP = "Please  wait ...";
                    this.showalertOTP = true;
                  
                    this.baService.addGenerateOTPData(objj)
                    .subscribe(
                          (datas) => {
                  
                            var str1=null;
                            str1= datas.toString();
                  
                            this.alertmsgOTP= str1 ;
                            this.showalertOTP=true;
                            setTimeout(() => {
                            this.showalertOTP=false;
                            }, 5000);
  
                            this.CK_Contact_Validation = true ; 
                  
                  
                    });
      
      
                  }
                    
        
          });
    

        }
        else
        {    
        
        this.baService.DuplicacyCheckForContactNOData( datas.ContactNo )
        .subscribe(
              (datas) => {
      
                var str1=null;
                str1 = datas[0].OperationStatus; 
      
              
                if( str1=='Contact No verified succesfully !' ){
    
                  var objj = new RegistrationBasicElement();
                  objj.ContactNo = this.CONTACTNO ;
                
                
                  this.alertmsgOTP = "Please  wait ...";
                  this.showalertOTP = true;
                
                  this.baService.addGenerateOTPData(objj)
                  .subscribe(
                        (datas) => {
                
                          var str1=null;
                          str1= datas.toString();
                
                          this.alertmsgOTP= str1 ;
                          this.showalertOTP=true;
                          setTimeout(() => {
                          this.showalertOTP=false;
                          }, 5000);

                          this.CK_Contact_Validation = true ; 
                
                
                  });
    
    
                }
                else if(  str1 =='Duplicate Conatct No Found !' )
                {
                                  
                          this.alertmsgOTP= str1 ;
                          this.showalertOTP=true;
                          setTimeout(() => {
                          this.showalertOTP=false;
                          }, 5000);

                          this.CK_Contact_Validation = false ; 

                          return;
    
                  
                }
    
                  
      
        });

        }
    
  
    }
                 

  });



}

onValidateOTPSubmit(datas){


  if( datas.ContactNo ==null  ){

    this.alertmsgOTP1="Contact No can not be blank to generate OTP !";
          this.showalertOTP1=true;
          setTimeout(() => {
          this.showalertOTP1=false;
          }, 2000);

     return;
  }
  else
  {

    if(  datas.ContactNo.length == 12  )
    {

    }
    else if(  datas.ContactNo.length < 12  )
    {

      this.alertmsgOTP1="Give 10 digit mobile number along with 91 i.e. 12 digits to generate OTP !";
          this.showalertOTP1=true;
          setTimeout(() => {
          this.showalertOTP1=false;
          }, 2000);

     return;

    }


  }

  if( datas.Code ==null  ){

    this.alertmsgOTP1="Code can not be blank to validate OTP !";
          this.showalertOTP1=true;
          setTimeout(() => {
          this.showalertOTP1=false;
          }, 2000);

     return;

  }else{

    if(  datas.Code.length == 4  )
    {


    }
    else   if(  datas.Code.length < 4  )
    {

      this.alertmsgOTP1="Give 4 digit code to validate OTP !";
          this.showalertOTP1=true;
          setTimeout(() => {
          this.showalertOTP1=false;
          }, 2000);

     return;


    }

  }

  var objj = new RegistrationBasicElement();
  objj.ContactNo = datas.ContactNo;
  objj.Code=datas.Code;

  this.alertmsgOTP1 = "Please  wait ...";
  this.showalertOTP1 = true;

  this.baService.addValidateOTPData(objj)
      .subscribe(
        (datas) => {

          var str1=null;
          str1= datas.toString();

          this.alertmsgOTP1= str1 ;
          this.showalertOTP1=true;
          setTimeout(() => {
          this.showalertOTP1=false;
          }, 5000);

        });



}

  
  

 getAllPersonIDCategory() {

  this.shareService.getAllPersonIDCategoryData()
    .subscribe(
      (datasx) => {

        this.personidData = datasx;

      }

    );
 }


 getAllSex() {

   this.shareService.getAllPersonSexData()
     .subscribe(
       (datasx) => {

         this.sexData = datasx;

       }

     );
  }
 getAllReligion() {

   this.shareService.getAllPersonReligionData()
     .subscribe(
       (datarel) => {

         this.religionData = datarel;

       }

     );
  }


 getAllRelation() {

   this.shareService.getAllPersonRelationData()
     .subscribe(
       (datarela) => {

         this.relationData = datarela;

       }

     );
  }

 getAllMarital() {

   this.shareService.getAllPersonMaritalData()
     .subscribe(
       (datamart) => {

         this.maritalData = datamart;

       }

     );
  }

 

 getAllBlood() {

   this.shareService.getAllPersonBloodData()
     .subscribe(
       (databloo) => {

         this.bloodData = databloo;

       }

     );
  }  

  getAllCountry() {

    this.shareService.getAllFillCountryData()
      .subscribe(
        (datacoun) => {
 
          this.countryData = datacoun;
 
        }
 
      );
  }
 

   /// leadsourceData
getLeadSourceList() {
  this.leadsourceData = [
 
    { HowKnowUs: "N/A" },
    { HowKnowUs: "Website Download" },
    { HowKnowUs: "Web Research" },
    { HowKnowUs: "Chat" },
    { HowKnowUs: "Email" },
    { HowKnowUs: "Public Relation" },
    { HowKnowUs: "Online Store" },
    { HowKnowUs: "Social Media" },
    { HowKnowUs: "Referral" },
    { HowKnowUs: "Cold Calling" },
    { HowKnowUs: "Advertisement" },
 
  ];
 }

 getYesNoList() {
  this.yesnoData = [
 
    { IsFamily: "N/A" },
    { IsFamily: "Yes" },
    { IsFamily: "No" },
   
 
  ];
 }


 
 getAllImgVcdCategory(msg="") {

  this.imgService.getAllImageVcdCategoryData(6)
  .subscribe(
    (data) => {

      this.imgvcdcategoryData = data;

     }

  );
}

 FillSession(){

  if (sessionStorage.getItem("OrderMaster_Id")) {   
    this.loggedIn = true;    
   // this.ResetPassword(); 
  } 
  else 
  {
    this.loggedIn = false; 
  }


 }

 
 loginredirect() {
  this.router.navigateByUrl("login");
}

 ResetPassword(){

  this.loginService.getPasswordReset(sessionStorage.getItem("UserName"))
  .subscribe((event: any) => {
    if (event.length > 0) {

    }
  });

 }

  ngOnInit() { 

  this.FillSession();
  this.EditOperation = false;    this.EditeditOperation = false;  

  this.LoadBasic();   

  this.RIDS="";    this.FNAME= "";   this.MID=0;

  this.CK_FM = false ;   this.CK_Contact_Validation = false ;
  this.AREANAME ="";  this.ZONENAME ="";

  this.CK71=true; this.basicForm.patchValue({ReferralAdmissionMasterId:''});

  this.ckVisibleOFF = false;  this.CKOTP = true;      
    
  this.CalculateTime();
  this.LoadVisitorData(); this.LoadMachineData();  

  }

  LoadVisitorData(){

    this.alertmsg="data loading ..... !!";
    this.showalert=true;

    this.baService.getAllRegistrationBasicData( "NO",Number(sessionStorage.getItem("LoggedInId")), 1, 13 )
    .subscribe((event: any) => {   

    if (event.length > 0) {
    this.customerdetails1 = event;
    } else {
    this.customerdetails1 = [];
    }
  
    }

    );
  
    this.alertmsg="data loading ..... !!";
    this.showalert=true;
    setTimeout(() => {
    this.showalert=false;
    }, 9000); 
  
  
  
  }

  LoadMachineData(){
    
  
    //////////////////////   STEP-001   /////////////////
    this.variService.getAllItemBasic2VariationByItemProductTypeId( 1 )
    .subscribe((event: any) => {   

    if (event.length > 0) {
    this.machineuseddetails1 = event;
    } else {
    this.machineuseddetails1 = [];
    }
  
    }

    );


    //////////////////////   STEP-002   /////////////////
    this.variService.getAllItemBasic2VariationByItemProductTypeId( 2 )
    .subscribe((event: any) => {   

    if (event.length > 0) {
    this.machineuseddetails2 = event;
    } else {
    this.machineuseddetails2 = [];
    }
  
    }

    );


    //////////////////////   STEP-003  /////////////////
    this.variService.getAllItemBasic2VariationByItemProductTypeId( 3 )
    .subscribe((event: any) => {   

    if (event.length > 0) {
    this.machineuseddetails3 = event;
    } else {
    this.machineuseddetails3 = [];
    }
  
    }

    );
     


  }

  onMachineSubmit(){

    if ( this.machineForm.get('machineuseddetails1')?.value == null  ) {

      this.alertmsg="Select at least among STEP-1 !";
      this.showalert = true;
      setTimeout(() => {
        this.showalert = false;
      }, 2000);
      return;

    }

    if ( this.machineForm.get('machineuseddetails2')?.value == null  ) {

      this.alertmsg="Select at least among STEP-2 !";
      this.showalert = true;
      setTimeout(() => {
        this.showalert = false;
      }, 2000);
      return;

    }

    if ( this.machineForm.get('machineuseddetails3')?.value == null  ) {

      this.alertmsg="Select at least among STEP-3 !";
      this.showalert = true;
      setTimeout(() => {
        this.showalert = false;
      }, 2000);
      return;

    }


    console.log(this.machineForm.value);
    // Example output: { machineuseddetails1: 2, machineuseddetails2: 3, machineuseddetails3: 6 }
    // Now you can send this to your API


    var objj = new RegistrationBasicElement();
    objj.AdmissionMasterId= this.MID;
    objj.CreatedBy =Number(sessionStorage.getItem("LoggedInId"));

    objj.ItemId1 = this.machineForm.get('machineuseddetails1')?.value;
    objj.ItemId2 = this.machineForm.get('machineuseddetails2')?.value;
    objj.ItemId3 = this.machineForm.get('machineuseddetails3')?.value;

    this.baService.addDailyUsedForMobile(objj).subscribe((datas) => {
    var str1 = null;    

    str1 = datas[0].OperationStatus.toString().split("#")[0];

    this.alertmsg1 = str1;
    this.showalert1 = true;
    setTimeout(() => {
    this.showalert1 = false;
    }, 2000);

    this.machineForm.reset();
    this.GetAllMachineAttendanceByMID();
    //this.MID=0;
       
    });


  }

  GetAllMachineAttendanceByMID(){

    this.baService.GetAllAdmissionMasterIdItemIdDailyUsedData( this.MID )
    .subscribe((event: any) => {   

    if (event.length > 0) {
    this.machineuseddetails = event;
    } else {
    this.machineuseddetails = [];
    }
  
    }

    );

    this.baService.GetAllAttendanceRegisterDetailsData( this.MID )
    .subscribe((event: any) => {   

    if (event.length > 0) {
    this.attendancedetails = event;
    } else {
    this.attendancedetails = [];
    }
  
    }

    );


  }
 
  

 /////////////////////////////////////////   IMAGE ///////////////////////////


 onImageListSubmit(res) {
  console.log(res);
  //var ImageId=0;
  var imgforid=3, other=[];
  //var MID=1;
  if (res.imagesList.length>0) {
  const formData = new FormData();
  res.imagesList.forEach(element => {


    //Other values
    console.log(this.MID);
    console.log(imgforid); //ImageForId 6
    console.log(element.ImageCategoryId); //Imagecategory Id 15 / 16 / 17 / 22
    if (element.image) {
      other.push({"ImageId":"0","MId":this.MID,"Name":element.image.name,"ImageForId":"3","ImageCategoryId":0,"Notes":"IMG","OperationType":"insert","CreatedBy":Number(sessionStorage.getItem("LoggedInId")),"MachineIP":sessionStorage.getItem("LongitudeLatitude"),"Default":"0","ItemVariationId":0,"F1":"","F2":"","F3":"" });
      element.image.totalname=element.image.name;
      element.image.totalname=element.image.totalname+"#"+element.ImageCategoryId+"#"+imgforid;
    }
    formData.append('file', element.image);
  });
  formData.append('params',JSON.stringify(other));

  this.alertmsg = "Please  wait for a moment , will start  uploading .... !!";
  this.showalert = true;

    this.uploadsvc.uploadData(formData)
     .subscribe((event: any) => {
        if (typeof (event) === 'object' && event.status==200) {
         console.log(event);

         this.alertmsg="Saved Successfully !";
         this.showalert=true;
         setTimeout(() => {
         this.showalert=false;
        }, 2000);


       }
      });



  }

  this.getimagesForMID();


}

get imagesList() {
  return this.imagesForm.get('imagesList') as FormArray;
}
addImageList() {
  this.imagesList.push(this.fb.group({ image: new FormControl(), ImageCategoryId: new FormControl()}));
}
deleteImageList(index) {

  this.imagesList.removeAt(index);


 //  ON DELETE BUTTON CLICK below values with operation delete will pass  which will make IsActive=0  for particular Image/VCD

//other.push({"ImageId":index,"MId":this.MID,"Name":element.image.name,"ImageForId":"4","ImageCategoryId":element.ImageCategoryId,"Notes":"IMG","OperationType":"delete","CreatedBy":"1","MachineIP":"1.1.1.1","Default":"0"});


}
deleteImage(image,content){

  this.imageToBeDeleted=image;
  this.confirmDeleteImageReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  this.confirmDeleteImageReference.result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
  }, (reason) => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  });
}
cancelImageModal(){
  this.empModalReference.close();
}
deleteImageConfirm1(){

  this.imgService.deleteImageVcdPathData(this.imageToBeDeleted.ImageId,this.imageToBeDeleted.MachineIP,this.imageToBeDeleted.CreatedBy)
  .subscribe(
    (data) => {


          });



      //console.log(data);
      // this.getAllCreditor("Deletion Successful");
      this.getimagesForMID();


    this.imageToBeDeleted=null;
    this.confirmDeleteImageReference.close();
}
cancelImage(){
 this.imageToBeDeleted=null;
   this.confirmDeleteImageReference.close();
}



getimagesForMID(){

  this.IMGFOR=3;
   // this.imgService.getAllImageVcdPathMapData(this.MID,'',this.IMGFOR)
   this.imgService.getAllImageVcdPathMapData(this.MID,"",this.IMGFOR,0,"","","",)
   .subscribe(
     (data) => {

      this.CK_IMG_PROFILE = true ;

         // --------  FILLING OF LIST OF IMAGES # VCD FROM DB -------------------
       //    api will return 2 tables - 1st  for Image Fill   , 2nd  for VCD fill

       /////// CK_IMG_PROFILE 

       ///   this.testELEMENT_DATA = data;
    ///   this.testdataSource = new      MatTableDataSource(this.testELEMENT_DATA);    
    ///    this.ROWCOUNT = Number(this.testdataSource.data.length);
      
        if(  this.ROWCOUNT > 0 )
        {

          this.imageList=[];
          this.CK_IMG_PROFILE = true ;   this.CK_IMG_NOPROFILE = false  ;

          this.IMAGE_ELEMENT_DATA=data;
          this.profile_img=data[0].Subdomainpaths;

          /// this.imageList=this.IMAGE_ELEMENT_DATA;
            ///this.imageDataSource = new MatTableDataSource(this.IMAGE_ELEMENT_DATA);
          ///this.imageDataSource.paginator = this.imagePaginator;

        }

         
        });


        this.imgService
        .getAllImageVcdPathMapData(this.MID,"",this.IMGFOR,0,"","","",)
        .subscribe((event: any) => {
          if (event.length > 0) {
            this.imageList = event;

            this.CK_IMG_PROFILE = true ; 
            this.profile_img=event[0].Subdomainpaths;

            ///   event[0].AdmissionMasterId,

              // if (event[0].OperationStatus == "Successfully Saved") {
             //   alert("done");
            // }

          } else {
            this.imageList = [];

          }
        });





}


///////////////////////////////   IMAGE /////////////////////////////


  onHeSubmit1(datas) {


    if(   this.MID== null || this.MID== 0  )
    {
  
        this.alertmsg="Fill up Essential Information First !";
              this.showalert=true;
              setTimeout(() => {
              this.showalert=false;
              }, 2000);
              return;
  
     }
  
    if(  datas.Height ==null ||  datas.Weight ==null    )
    {
  
        this.alertmsg="Health and Weight are mandatory must be filled with proper data!";
              this.showalert=true;
              setTimeout(() => {
              this.showalert=false;
              }, 2000);
        return;
  
     }else{
  
  
    var objj = new RegistrationHealthElement();
  
    objj.AdmissionMasterId=this.MID;
  
    objj.Height =datas.Height;
    objj.WeightStandard =datas.WeightStandard;
    objj.Weight =datas.Weight;
    objj.Waist =datas.Waist;
    objj.HealthIssue =datas.HealthIssue;
  
    this.HEALTH_HISTORY =datas.HealthIssue;
  
    objj.UnderTreatment =datas.UnderTreatment;
  
    objj.PracticeDeepSleep =datas.PracticeDeepSleep;
    objj.PracticeSleepHr =datas.PracticeSleepHr;
    objj.PracticeDailyWater =datas.PracticeDailyWater;
    objj.PracticeFoodHabit =datas.PracticeFoodHabit;
    objj.PracticeAddiction =datas.PracticeAddiction;
  
    objj.CreatedBy = Number(sessionStorage.getItem("LoggedInId"));
    objj.MachineIP = sessionStorage.getItem("LongitudeLatitude");
    objj.Notes ="";
  
   if (this.EditOperation==false)
    {
  
      objj.AdmissionHealthId = 0;
      objj.OperationType = "insert";
  
      this.heService.addRegistrationHealthData(objj)
        .subscribe(
          (datas) => {
  
            var str1=null;
            str1= datas[0].OperationStatus.toString();
  
            this.alertmsg=str1;
            this.showalert=true;
            setTimeout(() => {
            this.showalert=false;
            }, 2000);
  
            console.log(datas);
            // this.getAllHealth();
  
          });
    } else {
  
  
      objj.AdmissionHealthId = datas.AdmissionHealthId;
      objj.OperationType = "update";
  
      this.heService.addRegistrationHealthData(objj)
        .subscribe(
          (datas) => {
  
            var str1=null;
            str1= datas[0].OperationStatus.toString();
  
            this.alertmsg=str1;
            this.showalert=true;
            setTimeout(() => {
            this.showalert=false;
            }, 2000);
  
           console.log(datas);
           // this.getAllHealth();
  
          });
    }
  
     }

     this.healthForm1.reset();   
     this.EditOperation = false;  
     this.EditeditOperation = false;  
 
  
  }
  onHeClear1() {

    this.healthForm1.reset();
  
  }

  onIsFamilySelected(value){
    console.log(value);

    if (value == 'Yes') {
      ///this.isTrade = true;
      this.CK_FM = true ;
    }
    else{
  
      this.CK_FM = false ;
  
    }




  }

  onAreaSelected(value){
    console.log(value);
  
    ////this.AREANAME = value ;
  
    
    this.baService.addZoneAreaData( value , Number(sessionStorage.getItem("LoggedInId")) , '', 4 )
    .subscribe(
     (data) => {
   
       ///// this.areaData = data;
       ////this.ZONENAME = data[0].ZoneName ; 
       this.AREANAME = data[0].AreaName ;
  
    }
    );
  
  }
  onZoneSelected(value){
    console.log(value);
  
      //// this.ZONENAME = value ; 
   
    this.baService.addZoneAreaData( value , Number(sessionStorage.getItem("LoggedInId")) , '', 2 )
    .subscribe(
     (data) => {
   
       this.areaData = data;
  
  
       this.baService.addZoneAreaData( value , Number(sessionStorage.getItem("LoggedInId")) , '', 3 )
       .subscribe(
        (data) => {
      
          ///// this.areaData = data;
          this.ZONENAME = data[0].ZoneName ; 
       }
       );
    }
    );
  }

  getAllZone() {
    
    this.baService.addZoneAreaData( 0 , Number(sessionStorage.getItem("LoggedInId")) , '', 2  )
     .subscribe(
       (data) => {
         this.zoneData = data;
       }
     );
  
     this.basicForm.patchValue({ZoneId: 1 });
  
     this.baService.addZoneAreaData( 1 , Number(sessionStorage.getItem("LoggedInId")) , '', 2 )
     .subscribe(
      (data) => {
    
        this.areaData = data;
     }
     );
  
     this.basicForm.patchValue({AreaId: 1 });
  
  
  
  }

  openZoneModal(content) {

    this.zoneForm.reset();


   // Modal Block ------------------
  this.modalOption.backdrop = 'static';
  this.modalOption.keyboard = false;
   // Modal Block ------------------

   // this.companyModalReference = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});


  // Modal Block ------------------
  this.zoneModalReference = this.modalService.open(content, this.modalOption);
  // Modal Block ------------------

    this.zoneModalReference.result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });

       return false;

  }

  openAreaModal(content) {

    this.areaForm.reset();


   // Modal Block ------------------
  this.modalOption.backdrop = 'static';
  this.modalOption.keyboard = false;
   // Modal Block ------------------

   // this.companyModalReference = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});


  // Modal Block ------------------
  this.areaModalReference = this.modalService.open(content, this.modalOption);
  // Modal Block ------------------

    this.areaModalReference.result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });

       return false;

  }

  
  onZoneSubmit(data) {

    if( data.PopName ==null  ){
  
      this.alertmsg="Blank Data Cant Be Saved !";
            this.showalert=true;
            setTimeout(() => {
            this.showalert=false;
            }, 2000);
  
   }else{
  
  
    this.baService.addZoneAreaData( 0 , Number(sessionStorage.getItem("LoggedInId")) , data.PopName, 1 )
    .subscribe(
      (data) => {
  
      this.getAllZone();
  
      this.alertmsg="Insertion Successfull";
      this.showalert=true;
      setTimeout(() => {
        this.showalert=false;
      }, 2000);      
  
      }
    );
  
  
   }
  
    //this.companyModalReference.close();
     this.zoneModalReference.close();
  
  }
  
  onAreaSubmit(data) {
  
    if( data.PopName ==null  ){
  
      this.alertmsg="Blank Data Cant Be Saved !";
            this.showalert=true;
            setTimeout(() => {
            this.showalert=false;
            }, 2000);
  
   }else{
  
    
    this.baService.addZoneAreaData( data.ZoneId , Number(sessionStorage.getItem("LoggedInId")) , data.PopName, 1 )
    .subscribe(
      (data) => {
  
      this.getAllZone();
  
      this.alertmsg="Insertion Successfull";
      this.showalert=true;
      setTimeout(() => {
        this.showalert=false;
      }, 2000);      
  
      }
    );
  
   }
  
    //this.companyModalReference.close();
    this.areaModalReference.close();
  
  }

  onZoneClear() {
    this.zoneForm.reset();
   }
  
   onAreaClear() {
    this.areaForm.reset();
   } 

  convertDate(inputFormat) {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/')
   }


   getAllBasic() {


    this.alertmsg = "Please wait ... data loading  .... !!";
    this.showalert = true;

    this.baService.getAllRegistrationBasicData( "NO",Number(sessionStorage.getItem("LoggedInId")), 1,0 )
    .subscribe(
      (data) => {

        this.ELEMENT_DATA_basic = data;
        //this.dataSource_basic = new MatTableDataSource(this.ELEMENT_DATA_basic);
        //this.dataSource_basic.paginator = this.paginator;
        //this.dataSource_basic.sort = this.sort;

        this.ELEMENT_DATA_daily2011 = data;
        //this.dataSource_daily2011 = new MatTableDataSource(this.ELEMENT_DATA_daily2011);
        ///this.dataSource_daily2011.paginator = this.paginator;
        ///this.dataSource_daily2011.sort = this.sort;
 
        this.ELEMENT_DATA_daily2022 = data;
        //this.dataSource_daily2022 = new MatTableDataSource(this.ELEMENT_DATA_daily2022);
        ///this.dataSource_daily2022.paginator = this.paginator;
        ///this.dataSource_daily2022.sort = this.sort;

        //this.RIDS= data[0].RID.toString();
       // this.FNAME= data[0].FullName.toString();
        
      }

    );

    this.alertmsg = "Please wait ... data loading  .... !!";
    this.showalert = true;

    this.showalert = true;
    setTimeout(() => {
    this.showalert = false;
    }, 10000);


}

 


  onVitalSubmit(datas) {

  
    if(  this.CK_ID_REQ == true )
    {
   
     if(  datas.IDNO == '' || datas.IDNO == null  )
     {
   
       this.alertmsg="ID NO is mandatory !";
       this.showalert=true;
       setTimeout(() => {
       this.showalert=false;
       }, 2000);
     
       return;
   
   
     }
   
    }
    else
    {
   
    }
   
    if( 

              // datas.FullName ==null || datas.ContactNo ==null  ||  
             // this.ZONENAME == null  ||  this.AREANAME == null ||  
            // this.ZONENAME == ""  ||  this.AREANAME == "" || 
           // this.ZONENAME == 'N/A'  ||  this.AREANAME == 'N/A' ||
          // this.ZONENAME == 'All'  ||  this.AREANAME == 'All'  

       datas.FullName ==null || datas.ContactNo ==null  || 
       datas.ZoneId == null  ||  datas.AreaId == null ||  datas.ZoneId == ""  ||  datas.AreaId == "" 
            
       )
       {
   
         this.alertmsg="FullName, ContactNo, Zone, Area  are mandatory fields must be filled up with proper data !";
               this.showalert=true;
               setTimeout(() => {
               this.showalert=false;
               }, 2000);
   
               return;
   
    }
    else
      {
   
     var objj = new RegistrationBasicElement();
   
   
     objj.CompId = datas.CompId;
     objj.BranchId = datas.BranchId;
   
     objj.FullName = datas.FullName;
     /// objj.DOB = this.convertDate(datas.DOB);
     objj.DOB = datas.DOB ;
   
     if( this.convertDate(datas.DOB)=="12/12/2012"){
   
       objj.Age = "00";
   
     }else{
   
       objj.Age = datas.Age;
   
     }
   
   
     objj.SexId = datas.SexId;
     objj.ContactNo = datas.ContactNo;
     objj.Email = datas.Email;
   
     ///objj.AdmissionDate = this.convertDate(datas.AdmissionDate);
     objj.AdmissionDate = datas.AdmissionDate ;

     /// objj.AdmissionTime = datas.AdmissionTime;
     objj.AdmissionTime = datas.AdmissionTime ;
   
   
     objj.PersonIDCategoryId = datas.PersonIDCategoryId;
     objj.IDNO = datas.IDNO;
     objj.FamilyMembersCount = datas.FamilyMembersCount;
   
   
      ////objj.Country_Id = datas.Country_Id;
      ///objj.State_Id = datas.State_Id;
      //objj.City_Id = datas.City_Id;

      objj.Country_Id = 101 ;
      objj.State_Id = 1 ;
      objj.City_Id = 1 ;


      objj.AreaId = datas.AreaId;
      objj.ZoneId = datas.ZoneId;
      objj.PinCode = datas.PinCode;
      objj.TempAddress = datas.TempAddress;
      objj.PermanentAddress = datas.PermanentAddress;
   
   
     objj.ReligionId = datas.ReligionId;
     objj.MaritalStatusId = datas.MaritalStatusId;
     objj.BloodGroupId = datas.BloodGroupId;
     objj.Nationality =101;
   
     objj.HowKnowUs=datas.HowKnowUs;
     //objj.AdmissionMasterCategory="CUSTOMER";
     objj.AdmissionMasterCategoryId=1;
     //objj.AdmissionMasterCategorySubId=datas.AdmissionMasterCategorySubId;
     objj.AdmissionMasterCategorySubId=13;
   
     objj.AdmissionStatus=datas.AdmissionStatus;
    //   AdmissionStatus: new FormControl(),
   
     objj.Notes = "NA";
     objj.CreatedBy = Number(sessionStorage.getItem("LoggedInId"));
     objj.MachineIP = sessionStorage.getItem("LongitudeLatitude");
     objj.ReferralAdmissionMasterId=datas.ReferralAdmissionMasterId;
   
    if (this.EditOperation==false)
     {
   
       objj.AdmissionMasterId=0;
       objj.AdmissionPersonalId = 0;
       objj.OperationType = "insert";
   
       if( this.CK_Contact_Validation == false ){
   
         this.alertmsg="Verify Contact NO. is mandatory !";
         this.showalert=true;
         setTimeout(() => {
         this.showalert=false;
         }, 2000);
       
         return;
       
        }
   
       this.baService.addRegistrationBasicData(objj)
         .subscribe(
           (datas) => {
   
              var str1=null;
   
             str1= datas[0].OperationStatus.toString().split('#')[0];
             var str2= datas[0].OperationStatus.toString().split('#')[1];
             this.MID= str2;
   
             this.RIDS= datas[0].OperationStatus.toString().split('#')[2];
             this.FNAME= datas[0].OperationStatus.toString().split('#')[3];
             
             this.alertmsg=str1;
             this.showalert=true;
             setTimeout(() => {
             this.showalert=false;
             }, 2000);
   
             console.log(datas);
             
             /// this.getAllBasic();
            
   
           });
     } else {
   
       objj.AdmissionMasterId=this.MID;
       objj.AdmissionPersonalId = datas.AdmissionPersonalId;
       objj.OperationType = "update";
   
       this.baService.addRegistrationBasicData(objj)
         .subscribe(
           (datas) => {
   
             var str1=null;
           
             str1= datas[0].OperationStatus.toString().split('#')[0];
             var str2= datas[0].OperationStatus.toString().split('#')[1];
             this.MID= str2;
   
             this.RIDS= datas[0].OperationStatus.toString().split('#')[2];
             this.FNAME= datas[0].OperationStatus.toString().split('#')[3];
   
             this.alertmsg=str1;
             this.showalert=true;
             setTimeout(() => {
             this.showalert=false;
             }, 2000);
   
   
            console.log(datas);
            ///this.getAllBasic();
   
   
           });
     }
    
   
    }

    this.basicForm.reset();   
    this.EditOperation = false;  
    this.EditeditOperation = false;  
   
   
  }


  AccessIDCheckingRule(){

    //  ID_NO REQ -> YES/NO
  
      // this.CK_ID_REQ=true;
    // this.headerservice.getAllItemMasterHeaderSubDescBySubId( 0 , 8 , 5220 )
    this.popService.getAllAccessMAPPINGData( 'IN VISITOR ENTRIES ID NO IS MANDATORY' , 'VISITOR ENTRIES' , 2 )
    .subscribe(
    (data1) => {       
     
    //var spc1 = data1[0].ItemMasterHeaderSubDesc.toString().split("#")[0];
    this.AIDD = Number(data1[0].IsPermitted.toString());
     
    if(  this.AIDD == 1  )
    {
        
      this.CK_ID_REQ= true;    
  
    }
    else if(   this.AIDD == 0  )
    {
        
      this.CK_ID_REQ= false;  
  
    }
                   
  
    });
  
  
  
  }
   





}
